module.exports = __webpack_public_path__ + "/images/ico-nav-logout.05d8b9a.svg";